import { useParams } from "react-router-dom";

export default function ProgramDetails() {
  const { slug } = useParams();

  return (
      <div className="pt-24 max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-6 text-[#0A1A2F] text-center">
          {slug?.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
        </h1>

      {slug === "programming with scratch" ? (
    <div className="space-y-10">

      {/* Top Section: Image + Intro */}
      <div className="flex flex-col lg:flex-row gap-10 items-center">

        {/* Image */}
        <div className="w-full lg:w-1/2">
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#2E5C8A] to-[#00FFFF] rounded-[40px] opacity-20 blur-2xl group-hover:opacity-30 transition-opacity" />
            <div className="relative aspect-video rounded-[32px] overflow-hidden border-8 border-white shadow-2xl">
              <img
                // src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
                src= "/Whisk_scratch_AI.jpeg"
                alt="Scratch programming for kids"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Intro Text */}
        <div className="w-full lg:w-1/2 space-y-6">
          <p className="text-lg text-gray-600 leading-relaxed">
            Scratch Programming introduces learners to coding using visual blocks. Students create animations, games and interactive stories while learning the fundamentals of programming logic.
          </p>

          <div className="bg-[#E8F4FB] p-6 rounded-2xl">
            <h3 className="text-xl font-bold text-[#2E5C8A] mb-2">
              Example Project
            </h3>
            <p className="text-gray-700">
              Students build a simple game where a character moves, jumps and scores points based on user input — all using drag-and-drop code blocks.
            </p>
          </div>
        </div>
      </div>

      {/* Skills Section */}
      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
        <h3 className="text-xl font-bold text-[#0A1A2F] mb-4">
          What Students Will Learn
        </h3>
        <ul className="space-y-3 text-gray-600">
          <li>• Creating animations and simple games</li>
          <li>• Understanding sequences, loops and events</li>
          <li>• Building interactive stories</li>
          <li>• Developing logical thinking and creativity</li>
        </ul>
      </div>

    </div>
  ) : null
  // :  (
  //   <p className="text-lg text-gray-600">
  //     This is the program details page for: <strong>{slug}</strong>
  //   </p>
  // )
  }
  {slug === "web-development" ? (
  <div className="space-y-10">
    
    {/* Top Section: Image + Intro */}
    <div className="flex flex-col lg:flex-row gap-10 items-center">
      
      {/* Image */}
      <div className="w-full lg:w-1/2">
        <div className="relative group">
          <div className="absolute -inset-4 bg-gradient-to-r from-[#2E5C8A] to-[#00FFFF] rounded-[40px] opacity-20 blur-2xl group-hover:opacity-30 transition-opacity" />
          <div className="relative aspect-video rounded-[32px] overflow-hidden border-8 border-white shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
              alt="Web development for kids"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Intro Text */}
      <div className="w-full lg:w-1/2 space-y-6">
        <p className="text-lg text-gray-600 leading-relaxed">
          In this course, learners are introduced to the fundamentals of web development using HTML and CSS. They learn how to create, structure and style web pages while building their own simple websites through practical, hands-on projects.
        </p>

        <div className="bg-[#E8F4FB] p-6 rounded-2xl">
          <h3 className="text-xl font-bold text-[#2E5C8A] mb-2">
            What Students Build
          </h3>
          <p className="text-gray-700">
            Students design and develop their own web pages, combining structure (HTML) and styling (CSS) to create visually appealing and functional websites.
          </p>
        </div>
      </div>
    </div>

    {/* Skills Section */}
    <div className="grid md:grid-cols-2 gap-8">
      
      {/* HTML Skills */}
      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
        <h3 className="text-xl font-bold text-[#0A1A2F] mb-4">
          HTML Coding Skills
        </h3>
        <ul className="space-y-3 text-gray-600">
          <li>• Create and structure web pages using HTML</li>
          <li>• Understand how websites are built</li>
          <li>• Develop problem-solving through coding tasks</li>
          <li>• Build simple personal web pages</li>
          <li>• Express ideas through digital content</li>
        </ul>
      </div>

      {/* CSS Skills */}
      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
        <h3 className="text-xl font-bold text-[#0A1A2F] mb-4">
          CSS Styling Skills
        </h3>
        <ul className="space-y-3 text-gray-600">
          <li>• Style web pages using colours, fonts and layouts</li>
          <li>• Understand design in web development</li>
          <li>• Customize and improve visual appearance</li>
          <li>• Create attractive and responsive layouts</li>
          <li>• Build confidence in digital design</li>
        </ul>
      </div>

    </div>
  </div>
) : null}

{slug === "python-and-javascript-programming" ? (
  <div className="space-y-10">
    <div className="flex flex-col lg:flex-row gap-10 items-center">
      <div className="w-full lg:w-1/2">
        <div className="relative group">
          <div className="absolute -inset-4 bg-gradient-to-r from-[#2E5C8A] to-[#FFD700] rounded-[40px] opacity-20 blur-2xl" />
          <div className="relative aspect-video rounded-[32px] overflow-hidden border-8 border-white shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
              alt="Python and JavaScript programming for kids"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2 space-y-6">
        <p className="text-lg text-gray-600 leading-relaxed">
          Python and JavaScript Programming helps learners move from block-based coding to real text-based programming. Students learn how to write code, solve problems, build simple applications and make web pages interactive through practical projects.
        </p>

        <div className="bg-[#E8F4FB] p-6 rounded-2xl">
          <h3 className="text-xl font-bold text-[#2E5C8A] mb-2">
            What Students Build
          </h3>
          <p className="text-gray-700">
            Learners create simple Python programs such as calculators, quizzes and games, and use JavaScript to add buttons, animations, user input and interactive features to web pages.
          </p>
        </div>
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-8">
      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
        <h3 className="text-xl font-bold text-[#0A1A2F] mb-4">
          Python Skills
        </h3>
        <ul className="space-y-3 text-gray-600">
          <li>• Writing Python code</li>
          <li>• Using variables, inputs and conditions</li>
          <li>• Creating simple programs and games</li>
          <li>• Debugging basic errors</li>
          <li>• Solving problems step by step</li>
        </ul>
      </div>

      <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
        <h3 className="text-xl font-bold text-[#0A1A2F] mb-4">
          JavaScript Skills
        </h3>
        <ul className="space-y-3 text-gray-600">
          <li>• Writing basic JavaScript code</li>
          <li>• Making web pages interactive</li>
          <li>• Using clicks, buttons and user input</li>
          <li>• Creating simple animations</li>
          <li>• Combining creativity with web logic</li>
        </ul>
      </div>
    </div>
  </div>
) : null}
      </div>
  );
}